const TableData = [
    {
        sNo: '01',
        name: "Stem Borer",
        image1: 'Images/stemborer11.png',
        image2: 'Images/stemborer21.png',
        description: "Germination on lower side of the leaves. The larva of the chilo enters in the whorl and causesdamages in leaf",
        solutionName: 'Furadan 3G',
        solution: 'Images/FMC.png',
    },
    {
        sNo: '02',
        name: "Pink Borer",
        image1: 'Images/pinkborer1.png',
        image2: 'Images/pinkborer2.png',
        description: "The moth of Sesamia is nocturnal and lays egg on lower leaf shealth. The larve of the Sesamia enter the plant near the base and cause damage to stem.",
        solutionName: 'Fipronil',
        solution: "Images/fibronil-1.png",
    },
    // {
    //     sNo: 04,
    //     name: "",
    //     Image: 22,
    //     description: "",
    //     solution: "",
    // },
    // {
    //     sNo: 05,
    //     name: "",
    //     Image: 21,
    //     description: "",
    //     solution: "",
    // }
]
export default TableData;